import type * as ContractsModule from '@sunucupark/shared';

/**
 * The contracts, loaded when the first answer needs validating rather than
 * with the page (ADR 0006, bundle budget). Everything that validates goes
 * through here, because the module also switches zod into its `jitless` mode:
 * its faster path compiles validators with `new Function`, which the page's
 * Content Security Policy refuses — and a refused validator is a slower
 * validator plus a violation report, not a broken one.
 */
type Contracts = typeof ContractsModule;
let contracts: Promise<Contracts> | null = null;

export function loadContracts(): Promise<Contracts> {
  contracts ??= (async () => {
    // Order matters: zod compiles a schema's fast validator while the schema is
    // being created, so the switch has to be thrown before the contracts load.
    const zod = await import('zod');
    zod.config({ jitless: true });
    return import('@sunucupark/shared');
  })();
  return contracts;
}

/** A schema loader for `ApiClient`, e.g. `schema: contractSchema((c) => c.FolderListResponseSchema)`. */
export function contractSchema<T>(pick: (contracts: Contracts) => T): () => Promise<T> {
  return () => loadContracts().then(pick);
}
